module.exports = __webpack_public_path__ + "ad4b37a4cee12ef4b4a142d844d9c56a.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/tiers/trophy-shelf-5.png
// module id = 3009
// module chunks = 0